<template>
  <div class="width-box w600">
    <el-form class="pop-form-wrap" label-width="100px" :model="formData" ref="projectInfoForm" v-if="formData">
      <el-form-item label="Cover" prop="NbImg">
        <img-upload v-model="formData.NbImg" tip="Image recommended size：1920*225"></img-upload>
      </el-form-item>
      <el-form-item label="Name" prop="NbName">
        <el-input size="small" v-model="formData.NbName"></el-input>
      </el-form-item>
      <el-form-item label="Skip Url" prop="NbUrl">
        <el-input size="small" v-model="formData.NbUrl"></el-input>
      </el-form-item>
      <el-form-item label="Sort" prop="NbSort">
        <el-input size="small" v-model.number="formData.NbSort"></el-input>
      </el-form-item>
      <el-form-item label="Is Leaf" prop="IsLeaf" v-if="formData.NbFacode === '0'">
        <el-switch v-model="formData.IsLeaf" on-text="" off-text=""></el-switch>
      </el-form-item>
      <!-- 
      <el-form-item label="IsShow" prop="IsShow">
        <el-switch v-model="formData.IsShow" on-text="" off-text=""></el-switch>
      </el-form-item>
      <el-form-item label="IsLeaf" prop="IsLeaf" v-if="formData.NbFacode === '0'">
        <el-switch v-model="formData.IsLeaf" on-text="" off-text=""></el-switch>
      </el-form-item> -->
      <el-form-item label="SeoTitle" prop="SeoTitle">
        <el-input size="small" v-model="formData.SeoTitle"></el-input>
      </el-form-item>
      <el-form-item label="SeoDescribetion" prop="SeoDescribetion">
        <el-input size="small" v-model="formData.SeoDescribetion" :autosize="{minRows: 4}" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="SeoKey" prop="SeoKey">
        <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Add</el-button>
      </el-form-item>

      <el-form-item>
        <div class="pop-center-btn-wrap">
          <el-button type="primary" @click="doAdd('projectInfoForm')" v-if='!formData.Id'>add</el-button>
          <el-button type="primary" @click="doUpdate('projectInfoForm')" v-if='formData.Id'>save</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tools from '@/components/common/tools'
import imgUpload from '@/libcomponents/img-upload/img-upload'

// 数据对象
let dataStore = tools.createDataStore({
  NbFacode: '0',
  NbName: '',
  IsLeaf: false,
  IsShow: false,
  NbUrl: '',
  NbImg: '',
  NbSort: ''
})

// 请求相关操作
let page = {
  methods: {
    // add操作
    addDataAjax() {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.NbFacode === '0' ? (data.IsLeaf ? 1 : 0) : 1
      data.IsShow = data.IsShow ? 1 : 0
      data.SeoKey = this.dynamicTags.join(',')
      tools.commonAjax.call(this, true, '/Ajax/AddNavigationInAdmin', data).then(() => {
        this.$message.success('Operate success!')
        // add成功
        this.$emit('addSuccess')
      })
    },
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.NbFacode === '0' ? (data.IsLeaf ? 1 : 0) : 1
      data.IsShow = data.IsShow ? 1 : 0
      data.SeoKey = this.dynamicTags.join(',')
      tools.commonAjax.call(this, true, '/Ajax/UpdateNavigationInAdmin', data).then(() => {
        this.$message.success('Operate success!')
        // 修改成功
        this.$emit('updateSuccess')
      })
    }
  }
}

export default {
  name: 'NavigateionForm',
  componentName: 'NavigateionForm',
  mixins: [page],
  components: {
    imgUpload
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      formData: dataStore.getDefaultData()
    }
  },
  methods: {
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      var data = tools.extendData(dataStore.getDefaultData(), value || {})
      data.IsLeaf = !!value.IsLeaf
      data.IsShow = !!value.IsShow
      this.dynamicTags = data.SeoKey ? data.SeoKey.split(',') : []
      this.formData = data
    },
    // 发布
    doAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>




// WEBPACK FOOTER //
// NavigateionForm.vue?2c886378